import { Injectable } from '@jack-henry/frontend-utils/di';
import { RolesClient } from '@treasury/api/bo';
import { Role } from '../../../users/fi-user.entity';

@Injectable()
export class RolesService {
    constructor(private readonly rolesClient: RolesClient) {}

    /**
     *
     * @returns A promise that resolves to the list of roles.
     * @throws An error if the API call fails.
     */
    public async getRoles() {
        return (await this.rolesClient.rolesGetAll()).data.map(role => {
            return new Role(role);
        });
    }
}
